import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  colors,
  fonts,
  fontSizes,
} from "@softmax/design-system/tokens.stylex";
export const localStyles = stylex.create({
  main: {
    boxSizing: "border-box",
    marginInline: "auto",
    maxWidth: 1200,
    width: "100%",
    minWidth: 0,
    paddingTop: spacing.space64,
    paddingBottom: {
      default: spacing.space32,
      "@media (min-width: 1024px)": 40,
    },
    paddingInline: {
      default: spacing.space32,
      "@media (min-width: 768px)": spacing.space48,
      "@media (min-width: 1024px)": {
        default: spacing.space64,
        ":is(body:has([data-rail]) *)": spacing.space32,
      },
    },
    color: colors.foreground,
    fontFamily: fonts.sans,
  },
  embedded: {
    minWidth: 0,
    width: "100%",
    fontFamily: fonts.sans,
    color: colors.foreground,
  },
  grid: {
    display: "grid",
    gap: spacing.space32,
    gridTemplateColumns: {
      default: "minmax(0, 1fr)",
      "@media (min-width: 768px)": "15rem minmax(0, 1fr)",
    },
  },
  article: {
    order: { default: 1, "@media (min-width: 768px)": 2 },
    minWidth: 0,
  },
  notice: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: spacing.space8,
    margin: 0,
    fontSize: fontSizes.small,
  },
});
